import { PlayerServiceAPI } from '@API/data-services/player-service'
import { ResponseError } from '@Generated/back-office-client/src'
import { MagnifyingGlassIcon } from '@radix-ui/react-icons'
import { Button, Container, Flex, Heading, Section, TextField, Text } from '@radix-ui/themes'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'
import './styles.scss'
import { useNavigate } from 'react-router-dom'
import { Routes } from '@Components/main-app/types'

export const PlayerSearch = () => {
  const nav = useNavigate()
  const [playerSearchId, setPlayerSearchId] = useState<string>('')
  const [errorMessage, setErrorMessage] = useState<string | null>()

  const { mutate: searchPlayer, isPending } = useMutation({
    mutationFn: async () => {
      setErrorMessage(null)
      try {
        const details = await PlayerServiceAPI.getPlayerByLookup(playerSearchId)
        nav(Routes.PLAYER_DETAILS.replace(':lookupId', details.player.lookupId), {
          state: details,
        })
      } catch (e) {
        if (e instanceof ResponseError) {
          setErrorMessage((await e.response.json()).message)
        }
      }
    },
  })

  return (
    <Container className="player-search-container">
      <Section>
        <Flex direction="column" gap="3">
          <Heading as="h1" size="5">
            Player Lookup
          </Heading>
          <Heading as="h2" size="3">
            Search for a player to locate their details and activity.
          </Heading>

          <Flex gap="3">
            <TextField.Root
              className="player-id-lookup-field"
              placeholder="Search for a player by id"
              value={playerSearchId}
              onChange={(e) => {
                setPlayerSearchId(e.target.value)
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && playerSearchId) {
                  searchPlayer()
                }
              }}>
              <TextField.Slot>
                <MagnifyingGlassIcon height="16" width="16" />
              </TextField.Slot>
            </TextField.Root>

            <Button
              disabled={!playerSearchId}
              onClick={() => searchPlayer()}
              loading={!!playerSearchId && isPending}>
              Search
            </Button>

            <Button
              disabled={!playerSearchId}
              onClick={() => setPlayerSearchId('')}
              color="gray"
              variant="soft">
              Clear
            </Button>
          </Flex>

          {errorMessage ? <Text color="red">{errorMessage}</Text> : null}
        </Flex>
      </Section>
    </Container>
  )
}
